import {
  DEFAULT_CHATBOT_NODE_BACKGROUND_COLOR,
  DEFAULT_INTERFACE_NODE_BACKGROUND_COLOR,
  DEFAULT_NODE_BACKGROUND_COLOR,
  DEFAULT_NODE_COLOR,
  DEFAULT_TABLE_NODE_BACKGROUND_COLOR,
  DEFAULT_ZAP_NODE_BACKGROUND_COLOR,
  DEFAULT_AGENT_NODE_BACKGROUND_COLOR,
} from "@zapier/canvas-constants";
import { AssetType } from "@zapier/canvas-state";
import { lightenColor } from "./lightenColor";

const DEFAULT_BACKGROUND_COLORS_BY_ASSET_TYPE = {
  table: DEFAULT_TABLE_NODE_BACKGROUND_COLOR,
  interface: DEFAULT_INTERFACE_NODE_BACKGROUND_COLOR,
  chatbot: DEFAULT_CHATBOT_NODE_BACKGROUND_COLOR,
  zap: DEFAULT_ZAP_NODE_BACKGROUND_COLOR,
  agent: DEFAULT_AGENT_NODE_BACKGROUND_COLOR,
} as const;

type AssetTypeColorMap = typeof DEFAULT_BACKGROUND_COLORS_BY_ASSET_TYPE;

export function getDefaultBackgroundColorForAssetType(
  assetType: AssetType | undefined,
  color?: string,
): string {
  if (!assetType) {
    return !color || color === DEFAULT_NODE_COLOR
      ? DEFAULT_NODE_BACKGROUND_COLOR
      : lightenColor(color, 0.2, 1.5);
  }

  if (color) {
    return lightenColor(color, 0.2, 1.5);
  }

  return DEFAULT_BACKGROUND_COLORS_BY_ASSET_TYPE[
    assetType as keyof AssetTypeColorMap
  ];
}
